export const API_CONFIG = {
  GOBLIN_HOST: process.env.REACT_APP_API_GATEWAY_HOST_GOBLIN,
  // HOST: process.env.REACT_APP_API_GATEWAY_HOST,
  HOST :'https://shared-cable.plugo.io/api/shared-cable',
  PLUGO_REPORTS_API_HOST: process.env.REACT_APP_PLUGO_REPORTS_API_HOST,
  AUTH_KEY: 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBa2FzaCIsImlhdCI6MTc0NDE5NTcwMH0.63flaj9MUw3Svsj9GblpuagqUFDqJMKqfYW-2vPrenWCS285_cTOfZvgG2soGGqYT3Ek-Lu8BAn3WV2K7nGjMw'
};
